// Autogenerated file
export const graphHopperRoadTypesEnum = {
    Other: "Other",
    Motorway: "Motorway",
    Trunk: "Trunk",
    Primary: "Primary",
    Secondary: "Secondary",
    Tertiary: "Tertiary",
    Residential: "Residential",
    Unclassified: "Unclassified",
    Service: "Service",
    Road: "Road",
    Track: "Track",
    Bridleway: "Bridleway",
    Steps: "Steps",
    Cycleway: "Cycleway",
    Path: "Path",
    LivingStreet: "LivingStreet",
    Footway: "Footway",
    Pedestrian: "Pedestrian",
    Platform: "Platform",
    Corridor: "Corridor",
};
export const graphHopperRoadTypes = [
    { label: "Other", value: "Other" },
    { label: "Motorway", value: "Motorway" },
    { label: "Trunk", value: "Trunk" },
    { label: "Primary", value: "Primary" },
    { label: "Secondary", value: "Secondary" },
    { label: "Tertiary", value: "Tertiary" },
    { label: "Residential", value: "Residential" },
    { label: "Unclassified", value: "Unclassified" },
    { label: "Service", value: "Service" },
    { label: "Road", value: "Road" },
    { label: "Track", value: "Track" },
    { label: "Bridleway", value: "Bridleway" },
    { label: "Steps", value: "Steps" },
    { label: "Cycleway", value: "Cycleway" },
    { label: "Path", value: "Path" },
    { label: "LivingStreet", value: "LivingStreet" },
    { label: "Footway", value: "Footway" },
    { label: "Pedestrian", value: "Pedestrian" },
    { label: "Platform", value: "Platform" },
    { label: "Corridor", value: "Corridor" },
];
